import React, { forwardRef, useState, useRef } from 'react'
import { Box, List, ListItem } from '@material-ui/core'
import { useStyles, ListItemText } from './styles'
import Icon from '@mdi/react'
import { mdiChevronUp } from '@mdi/js'
import { Button, Dropdown } from '../../root/components/common'
import { useEffect } from 'react'
import PropTypes from 'prop-types'
import Checkbox from '@material-ui/core/Checkbox'
import { DatePicker } from '@material-ui/pickers'
import { isSelectedConnectivity } from '../utils/connectivity-heatmap'

export const ListComponent = forwardRef(
    (
        {
            toggleDropDown,
            setToggleDropDown,
            listItems,
            filterDevices,
            heatmapFilters,
            applyHeatmapFilter,
            hasFiltersChanged,
            resetHeatmapFilters,
            locale
        },
        ref
    ) => {
        const [collapse, setCollapse] = useState(false)
        const [filters, setFilters] = useState([])
        const activeListRef = useRef()
        const active = useRef('')
        const {
            startDate,
            endDate,
            reportTypes: checkedHeatmapTypes
        } = heatmapFilters

        const classes = useStyles()

        useEffect(() => {
            if (toggleDropDown) setCollapse(false)
        }, [toggleDropDown])

        const checkboxHandler = e => {
            const filterItem = e.target.value
            let updatedFilters
            if (filters.includes(filterItem)) {
                updatedFilters = filters.filter(e => e !== filterItem)
            } else {
                updatedFilters = [...filters, filterItem]
            }
            setFilters(updatedFilters)
            filterDevices(updatedFilters)
        }

        const resetAllFilters = () => {
            filterDevices([])
            setFilters([])

            resetHeatmapFilters()
        }

        return (
            <Dropdown
                anchorEl={ref.current}
                isOpen={toggleDropDown}
                close={() => setToggleDropDown(false)}
                className={classes.dropdown}
                customWrapper={classes.dropdownCustomWrapper}
                placement="down"
            >
                <>
                    {!isSelectedConnectivity(checkedHeatmapTypes) && (
                        <Box className={classes.datePickerWrapper}>
                            <DatePicker
                                disableToolbar
                                autoOk
                                disableFuture
                                InputProps={{
                                    classes: {
                                        root: classes.datePickerInput
                                    }
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.datePickerInputLabel
                                    }
                                }}
                                inputVariant="outlined"
                                disabled={isSelectedConnectivity(
                                    checkedHeatmapTypes
                                )}
                                variant="inline"
                                label={locale.reports.filterFrom}
                                format="DD/MM/YYYY"
                                value={startDate}
                                onChange={value => {
                                    applyHeatmapFilter('startDate', value)
                                }}
                            />
                            <DatePicker
                                disableToolbar
                                autoOk
                                disableFuture
                                InputProps={{
                                    classes: {
                                        root: classes.datePickerInput
                                    }
                                }}
                                InputLabelProps={{
                                    classes: {
                                        root: classes.datePickerInputLabel
                                    }
                                }}
                                minDate={startDate}
                                disabled={isSelectedConnectivity(
                                    checkedHeatmapTypes
                                )}
                                variant="inline"
                                inputVariant="outlined"
                                label={locale.reports.filterTo}
                                format="DD/MM/YYYY"
                                value={endDate}
                                onChange={value => {
                                    applyHeatmapFilter('endDate', value)
                                }}
                            />
                        </Box>
                    )}
                    <List component="ul">
                        {listItems.map((item, index) => {
                            return (
                                <ListItem
                                    key={index}
                                    ref={activeListRef}
                                    className={classes.listItem}
                                    onClick={e => {
                                        active.current = item.id
                                        activeListRef.current = e.currentTarget
                                        setCollapse(true)
                                    }}
                                >
                                    <ListItemText primary={item.text} />
                                    <Icon
                                        size={0.6}
                                        rotate={90}
                                        path={mdiChevronUp}
                                    />

                                    <Dropdown
                                        anchorEl={activeListRef.current}
                                        isOpen={
                                            active.current === item.id &&
                                            collapse
                                        }
                                        close={() => setCollapse(false)}
                                        className={classes.dropdown2}
                                        customWrapper={
                                            classes.dropdownCustomWrapper
                                        }
                                    >
                                        <List component="ul">
                                            {item.subLists.map(
                                                (item, index) => {
                                                    return (
                                                        <ListItem
                                                            key={index}
                                                            disableGutters={
                                                                true
                                                            }
                                                            className={
                                                                classes.checkboxWrapper
                                                            }
                                                        >
                                                            <Checkbox
                                                                checked={filters.includes(
                                                                    item.id
                                                                )}
                                                                size="small"
                                                                id={item.id}
                                                                value={item.id}
                                                                onChange={
                                                                    checkboxHandler
                                                                }
                                                            />
                                                            <ListItemText
                                                                primary={
                                                                    item.text
                                                                }
                                                            />
                                                        </ListItem>
                                                    )
                                                }
                                            )}
                                        </List>
                                    </Dropdown>
                                </ListItem>
                            )
                        })}
                    </List>
                    {hasFiltersChanged && (
                        <Box
                            className={
                                classes.resetButtonFloorPlanFiltersWrapper
                            }
                        >
                            <Button onClick={resetAllFilters}>
                                {locale.common.clear}
                            </Button>
                        </Box>
                    )}
                </>
            </Dropdown>
        )
    }
)

ListComponent.propTypes = {
    toggleDropDown: PropTypes.func.isRequired,
    setToggleDropDown: PropTypes.func.isRequired,
    listItems: PropTypes.array.isRequired
}
